require('./typeAccountFilter.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @ helpers

class TypeAccountFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.immFilter.toJS().typeAccount.value,
        };

        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    handleFilterChange(value) {
        const selected = value;
        this.setState({
            selected,
        });
        this.props.onChangeSelected(value);
    }

    render() {
        const { selected } = this.state;
        return (
            <section className="type-account-filter">
                <header className="type-account-filter__title">
                    <FormattedText value="typeAccountFilter-title" />
                </header>
                <RadioButtonGroup
                    name="type-account-filter"
                    idPrefix="type-account-filter-radio"
                    selectedValue={selected}
                    onChange={this.handleFilterChange}
                    className="group-contracts-filter__options"
                >
                    <RadioButton
                        label={formatText('typeAccountFilter-allAccounts')}
                        value="all"
                        className="group-contracts-filter__radio-button"
                    />
                    <RadioButton
                        label={formatText('typeAccountFilter-customAccounts')}
                        value="custom"
                        className="group-contracts-filter__radio-button"
                    />
                </RadioButtonGroup>
            </section>
        );
    }
}

TypeAccountFilter.propTypes = {
    immFilter: PropTypes.array,
    onChangeSelected: PropTypes.func.isRequired
};

module.exports = TypeAccountFilter;
